import cn from "classnames";
import React from "react";
import { TableComponentProps, TableComponent } from "./TableComponent";

export type InputProps = TableComponentProps & {
  numbersOnly?: boolean;
  currencyOnly?: boolean;
};

// cross-browser number only field, type="number" behaves differently between them
const lockNumberKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);

  if (!/^\d+$/.test(keyValue)) {
    event.preventDefault();
  }
};

// cross-browser number only field, type="number" behaves differently between them
const lockDecimalKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);

  if (!/^[-.\d]+$/.test(keyValue)) {
    event.preventDefault();
  }
};

export const TableInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      errors,
      className,
      error,
      label,
      name,
      numbersOnly = false,
      currencyOnly = false,
      onKeyPress,
      ...inputProps
    }: InputProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <TableComponent errors={errors} label={label} error={error} name={name}>
        <input
          className={cn(
            "w-9/12 px-2 py-1",
            "rounded-sm border border-border focus:shadow",
            "font-title text-2xl text-title tracking-barcode",
            className
          )}
          name={name}
          onKeyPress={
            currencyOnly
              ? lockDecimalKeys
              : onKeyPress || numbersOnly
              ? lockNumberKeys
              : undefined
          }
          ref={ref}
          {...inputProps}
        />
      </TableComponent>
    );
  }
);
